import api from "api/api";
import apiCarteira from "api/api-carteira";
import { openModalConfirm } from "components/modal-confirm-new";
import { Toast } from "components/toast";
import { User } from "contexts/types/application-context-types";
import { SelectedCustomer } from "pages/carteira/page";

export function handleCashback({
  cashbackButtonLabel,
  setSelectedCustomer,
  user,
  selectedCustomer
}: {
  cashbackButtonLabel: "Desativar Cashback" | "Ativar Cashback" | null;
  user: User;
  setSelectedCustomer: React.Dispatch<React.SetStateAction<SelectedCustomer>>;
  selectedCustomer: SelectedCustomer;
}) {
  if (cashbackButtonLabel === "Ativar Cashback") {
    openModalConfirm({
      message: "Deseja solicitar a ativação do cashback?",
      onConfirm: async () => {
        try {
          const { data } = await api.get(
            `/customers/${selectedCustomer.id}/change-cashback?status=PENDING`
          );
          Toast({ title: "Cashback Solicitado" });
          setSelectedCustomer({
            ...selectedCustomer,
            cashback: "PENDING"
          });
        } catch (e) {
          Toast({ title: "Erro ao solicitar cashback" });
        }
      },
      confirmButtonStyle: { variant: undefined }
    });
  } else if (cashbackButtonLabel === "Desativar Cashback") {
    openModalConfirm({
      message: "Deseja desativar o cashback?",
      onConfirm: async () => {
        try {
          const { data } = await api.get(
            `/customers/${selectedCustomer.id}/change-cashback?status=DISABLED`
          );
          Toast({ title: "Cashback Desativado" });
          setSelectedCustomer({
            ...selectedCustomer,
            cashback: "DISABLED"
          });
        } catch (e) {
          Toast({ title: "Erro ao desativar cashback" });
        }
      }
    });
  }
}

export interface TransacaoExtratoCarteira {
  data: string;
  descricao: string;
  tipoValor: "CREDITO" | "DEBITO";
  valor: number;
  valorEsperado: number | null;
  observacao: string | null;
}
export class CarteiraEndpoints {
  static async getSaldoCarteira(customerId: number) {
    const response = await apiCarteira.get<{
      saldos: { tipoCarteira: "GERAL" | "FGTS" | "CASHBACK"; saldo: number }[];
    }>(`/carteiras/saldo/${customerId}`);
    return response.data;
  }

  static async getCarteiraData(customerId: number) {
    const response = await apiCarteira.get<{
      saldos: { tipoCarteira: "GERAL" | "FGTS" | "CASHBACK"; saldo: number }[];
      saldo: number;
      transacoes: TransacaoExtratoCarteira[];
    }>(`/carteiras/extrato/${customerId}`);
    return response.data;
  }
}

export function getWalletBalanceFormatted(
  balances: { tipoCarteira: "GERAL" | "FGTS" | "CASHBACK"; saldo: number }[]
) {
  const geral = balances.find((b) => b.tipoCarteira === "GERAL")?.saldo || 0;
  const cashback =
    balances.find((b) => b.tipoCarteira === "CASHBACK")?.saldo || 0;

  return geral + cashback;
}
